import * as React from 'react';
import { Autocomplete, TextField, Chip, createFilterOptions } from '@mui/material';

const filter = createFilterOptions();

export default function MultipleSelectChip({ tags, selectedTags, onChange, isReadOnly }) {
  return (
    <Autocomplete
      multiple
      fullWidth
      readOnly={isReadOnly}
      sx={{ mb: 2 }}
      value={selectedTags || []}
      onChange={(event, newValue) => {
        const processedValues = newValue.map(option => {
          if (option.inputValue) {
            return {
              id: null,
              name: option.inputValue
            };
          }
          return option;
        });
        onChange(processedValues);
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        const { inputValue } = params;

        const isExisting = options.some((option) => inputValue.toLowerCase() === option.name.toLowerCase());
        const isAlreadySelected = (selectedTags || []).some((tag) => inputValue.toLowerCase() === tag.name.toLowerCase());

        if (inputValue !== '' && !isExisting && !isAlreadySelected) {
          filtered.push({
            inputValue,
            name: `Add tag "${inputValue}"`,
          });
        }

        return filtered;
      }}
      options={tags}
      isOptionEqualToValue={(option, value) => {
        if (option.id === null && value.id === null) {
          return option.name === value.name || option.inputValue === value.name;
        }
        return option.id === value.id;
      }}
      getOptionLabel={(option) => {
        if (typeof option === 'string') return option;
        if (option.inputValue) return option.inputValue;
        return option.name;
      }}
      renderOption={(props, option) => (
        <li {...props} key={option.id ? `opt-${option.id}` : `new-${option.name}`}>
          {option.name}
        </li>
      )}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            label={option.name}
            color="primary"
            variant="outlined"
            {...getTagProps({ index })}
            key={option.id ? `chip-${option.id}` : `chip-new-${index}`}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="Tags"
          placeholder="Type for search or create ..."
        />
      )}
    />
  );
}
